<template>
    <div>
        <!--   Create estimate for quickbook     -->
        <div class="modal fade" id="createEstimateQuickBook" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLongTitle"><img class="qb-small-logo-estimate" src="https://prod-followupcrm.s3.us-east-2.amazonaws.com/qb-logo-small.png"><span v-if="selectedEstimateForEdit">Update</span><span v-else>Create</span> Estimate</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeQuickBookCreateModal()">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body bg-white">
                        <div id="loadingoverlay">
                            <div class="cv-spinner">
                                <span class="spinner"></span>
                                <span class="text-white ml-4 text-xl ">Loading QuickBooks Customers</span>
                            </div>
                        </div>
                        <div id="createloadingoverlay">
                            <div class="cv-spinner">
                                <span class="spinner"></span>
                                <span class="text-white ml-4 text-xl "><span v-if="selectedEstimateForEdit">Updating</span><span v-else>Creating</span> QuickBooks Estimate</span>
                            </div>
                        </div>
                        <div class="row d-flex align-items-baseline px-4 mb-2">
                            <div class="col-md-2 p-0 m-0">
                                <label class="text-black text-sm p-0 m-0 pr-1">Customer Name</label>
                            </div>
                            <div class="col-md-7">
                                <multiselect
                                    class="cursor-pointer w-full"
                                    :options="qbCustomers"
                                    v-model="selectedQBCustomer"
                                    label="DisplayName"
                                    placeholder="Search and Select..."
                                    :multiple="false"
                                    track-by="Id"
                                    :show-labels="true"
                                    :taggable="false"
                                    :close-on-select="true"
                                    :disabled="(selectedEstimateForEdit || project.quick_book_customer_id)? true:false"
                                >
                                </multiselect>
                            </div>
                            <div class="col-md-3">
                                <button type="button" class="btn btn-primary w-full" @click="createQBCustomerModal()" v-if="(selectedEstimateForEdit || project.quick_book_customer_id)? false:true">Create customer</button>
                            </div>
                        </div>
                        <div class="row d-flex align-items-baseline px-4 mb-2">
                            <div class="col-md-12 p-0 m-0">
                                <button type="button" class="btn btn-primary" @click="addLineItemsMethod" v-if="!addLineItems">Add Line Items</button>
                            </div>
                        </div>
                        <div class="row d-flex align-items-baseline px-4 mb-2" v-if="addLineItems">
                            <div class="col-md-12 p-0 m-0" style="min-height: 60vh;max-height: 60vh;overflow-x: hidden;overflow-y: auto;">
                                <label class="text-white text-sm p-0 m-0 p-2 mb-2 bg-primary rounded-sm">Line Items</label>
                                <div class="row d-flex align-items-end px-4 mb-2" v-for="(quickBookContractItem, index) in quickBookContractItems">
                                    <div class="col-md-4 px-1 m-0">
                                        <label class="text-black text-sm p-0 m-0">Item / product & service</label>
                                        <multiselect
                                            class="cursor-pointer w-full"
                                            :options="productAndServices"
                                            v-model="quickBookContractItem.item"
                                            label="Name"
                                            placeholder="Search and Select..."
                                            :multiple="false"
                                            track-by="Id"
                                            :show-labels="false"
                                            :taggable="true"
                                            :close-on-select="true"
                                            @select="calculateItemSubTotal(index)"
                                            :disabled="!quickBookContractItem.editable"
                                        >
                                        </multiselect>
                                    </div>
                                    <div class="col-md-2 px-1 m-0">
                                        <label class="text-black text-sm p-0 m-0">Price per unit</label>
                                        <input type="text" class="form-control shadow-none" v-model="quickBookContractItem.value" readonly>
                                    </div>
                                    <div class="col-md-2 px-1 m-0">
                                        <label class="text-black text-sm p-0 m-0">Quantity</label>
                                        <input
                                            type="number"
                                            min="1" step="1"
                                            class="form-control shadow-none"
                                            v-model.number="quickBookContractItem.quantity"
                                            :readonly="!quickBookContractItem.editable"
                                            maxlength='4'
                                            @input="quickBookContractItem.quantity = $event.target.value.slice(0, 5).replace(/\D/g, ''); calculateItemSubTotal(index)"
                                            @focus="() => {(quickBookContractItem.quantity == 0)? quickBookContractItem.quantity = '':quickBookContractItem.quantity = quickBookContractItem.quantity}"
                                            @blur="() => {(quickBookContractItem.quantity == '' || quickBookContractItem.quantity == null || quickBookContractItem.quantity == undefined)? quickBookContractItem.quantity = 0:quickBookContractItem.quantity = quickBookContractItem.quantity}">
                                    </div>
                                    <div class="col-md-2 px-1 m-0">
                                        <label class="text-black text-sm p-0 m-0">Item total</label>
                                        <input type="text" class="form-control shadow-none" v-model="quickBookContractItem.subTotal" readonly>
                                    </div>
                                    <div class="col-md-2 px-1 m-0">
                                        <label class="text-black text-sm p-0 m-0"></label>
                                        <button type="button" class="btn btn-primary" title="Add Item" @click="addItemToQuickBookContractItems">+</button>
                                        <button type="button" class="btn btn-danger ml-1" title="Remove Item" @click="removeItemFromQuickBookContractItems(index)" v-if="quickBookContractItem.editable">-</button>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                    <div class="modal-footer bg-white">
                        <div v-if="!selectedEstimateForEdit" class="customerInformationTooltip cursor-pointer" title="Customer selected here cannot be changed for further estimates"><i class="fa fa-info-circle" aria-hidden="true"></i></div>
                        <button type="button" class="btn btn-secondary" data-dismiss="modal" @click="closeQuickBookCreateModal()">Close</button>
                        <button v-if="selectedEstimateForEdit" type="button" class="btn btn-primary" :disabled="buttonDisabled" @click="updateEstimate">Update Estimate</button>
                        <button v-else type="button" class="btn btn-primary" :disabled="buttonDisabled" @click="createEstimate">Create Estimate</button>
                    </div>
                </div>
            </div>
        </div>

        <!--   Create QB customer from project contact    -->
        <div class="modal fade" id="createQBCustomerModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLongTitle"><img class="qb-small-logo-estimate" src="https://prod-followupcrm.s3.us-east-2.amazonaws.com/qb-logo-small.png">Create QuickBooks Customer With Project Contact</h5>
                        <button type="button" class="close" aria-label="Close" @click="createQBCustomerModalClose()">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body bg-white">
                        <div>
                            <multiselect
                                id="selectProjectOrCompanyContactForQB"
                                v-model="selectedContactForQB"
                                :options="optionsForQBArray"
                                :multiple="false"
                                :close-on-select="true"
                                :clear-on-select="false"
                                :preserve-search="false"
                                :taggable="false"
                                open-direction="below"
                                placeholder="Pick a Contact"
                                :showLabels="false"
                                label="displayName"
                                track-by="id"
                                :preselect-first="false"
                                group-values="contact_options"
                                group-label="contact_type"
                                :group-select="false">
                            </multiselect>
                        </div>
                        <div class="loadingoverlayCustomer">
                            <div class="cv-spinner">
                                <span class="spinner"></span>
                                <span class="text-white ml-4 text-xl ">Creating/Linking QuickBooks Customer</span>
                            </div>
                        </div>
                        <div class="mt-2" v-if="selectedContactForQB">
                            <h5 class="font-weight-light text-white bg-primary mx-3 p-2">Contact Information</h5>
                            <div class="row mx-3 text-sm">
                                <div class="col-3 border-1 text-break  p-2 bg-grey-lighter">
                                    Name
                                </div>
                                <div class="col-3 border-1 text-break  border-l-0 p-2 text-sm">
                                    {{ selectedContactForQB.name }}
                                </div>
                                <div class="col-3 border-1 text-break  p-2 bg-grey-lighter border-l-0">
                                    Email
                                </div>
                                <div class="col-3 border-1 text-break  border-l-0 p-2 border-l-0">
                                    {{  selectedContactForQB.email }}
                                </div>
                            </div>
                            <div class="row mx-3 text-sm">
                                <div class="col-3 border-1 text-break  p-2 bg-grey-lighter border-t-0">
                                    Type
                                </div>
                                <div class="col-3 border-1 text-break  border-l-0 p-2 border-t-0">
                                    {{  (selectedContactForQB.type == 'project_contact')? 'Project Contact':'Company Contact' }}
                                </div>
                                <div class="col-3 border-1 text-break  p-2 bg-grey-lighter border-t-0 border-l-0">
                                    Cell
                                </div>
                                <div class="col-3 border-1 text-break  border-l-0 p-2 border-t-0 border-l-0">
                                    {{  selectedContactForQB.cell }}
                                </div>
                            </div>
                            <div class="row mx-3 text-sm" v-if="projectContactCompany && selectedContactForQB.type == 'project_contact'">
                                <div class="col-3 border-1 text-break  p-2 bg-grey-lighter border-t-0">
                                    Company name
                                </div>
                                <div class="col-3 border-1 text-break  border-l-0 p-2 border-t-0">
                                    {{  projectContactCompany.name }}
                                </div>
                                <div class="col-3 border-1 text-break  p-2 bg-grey-lighter border-t-0 border-l-0">
                                    Company Address
                                </div>
                                <div class="col-3 border-1 text-break  border-l-0 p-2 border-t-0 border-l-0">
                                    {{  projectContactCompany.address }}
                                </div>
                            </div>
                            <div class="row mx-3 text-sm" v-if="selectedContactForQB.company && selectedContactForQB.type == 'company_contact'">
                                <div class="col-3 border-1 text-break  p-2 bg-grey-lighter border-t-0">
                                    Company name
                                </div>
                                <div class="col-3 border-1 text-break  border-l-0 p-2 border-t-0">
                                    {{  selectedContactForQB.company.name }}
                                </div>
                                <div class="col-3 border-1 text-break  p-2 bg-grey-lighter border-t-0 border-l-0">
                                    Company Address
                                </div>
                                <div class="col-3 border-1 text-break  border-l-0 p-2 border-t-0 border-l-0">
                                    {{  selectedContactForQB.company.address }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer bg-white">
                        <button type="button" class="btn btn-secondary" @click="createQBCustomerModalClose()">Close</button>
                        <button type="button" class="btn btn-primary" @click="createQBCustomer('forEstimate')" :disabled="buttonDisabled">Create/Link Customer</button>
                    </div>
                </div>
            </div>
        </div>

        <!--   List QB estimates   -->
        <div class="modal fade" id="listQBEstimatesModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLongTitle"><img class="qb-small-logo-estimate" src="https://prod-followupcrm.s3.us-east-2.amazonaws.com/qb-logo-small.png">QuickBooks Estimate(s)</h5>
                        <button type="button" class="close" aria-label="Close" @click="closeQuickBookEstimateListModal()">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body bg-white">
                        <div id="accordion">
                            <div class="card shadow-none border-1 mb-3" v-if="qbEstimates.length > 0" v-for="(qbEstimate, index) in qbEstimates">
                                <div class="card-header p-1 bg-grey-light" :id="'heading'+index">
                                    <h5 class="mb-0">
                                        <button class="btn btn-link w-full text-left text-decoration-none focus:shadow-none shadow-none text-black text-sm hover:text-black" data-toggle="collapse" :data-target="'#collapse'+index" aria-expanded="true" :aria-controls="'collapse'+index">
                                            Estimate {{ qbEstimate.Estimate.Id }} - ${{ qbEstimate.Estimate.TotalAmt }} <span class="float-right">Created At: {{ formatEstimateDate(qbEstimate.time) }} <i class="fa fa-pencil ml-4" aria-hidden="true"></i></span>
                                        </button>
                                    </h5>
                                </div>

                                <div :id="'collapse'+index" class="collapse" aria-labelledby="headingOne" data-parent="#accordion">
                                    <div class="card-body border-t-1 bg-white">
                                        <div class="row m-0 p-0 text-sm">
                                            <div class="col-3 border-1 text-break  p-2 bg-grey-lighter">
                                                Customer Name
                                            </div>
                                            <div class="col-3 border-1 text-break  border-l-0 p-2 text-sm">
                                                {{ qbEstimate.Estimate.CustomerRef.name }}
                                            </div>
                                            <div class="col-3 border-1 text-break  p-2 bg-grey-lighter border-l-0">
                                                Billing Email
                                            </div>
                                            <div class="col-3 border-1 text-break  border-l-0 p-2 border-l-0">
                                                {{  qbEstimate.Estimate.BillEmail.Address }}
                                            </div>
                                        </div>
                                        <div class="row m-0 p-0 text-sm" v-if="qbEstimate.Estimate.Line.length > 0">
                                            <div class="col-12 border-1 text-break p-2 bg-primary border-t-0 text-white">
                                                Line Items
                                            </div>
                                        </div>
                                        <div class="row m-0 p-0 text-sm" v-if="qbEstimate.Estimate.Line.length > 0">
                                            <div class="col-3 border-1 text-break  p-2 bg-grey-lighter border-t-0">
                                                Item name
                                            </div>
                                            <div class="col-3 border-1 text-break  border-l-0 p-2 text-sm bg-grey-lighter border-t-0">
                                                Unit price
                                            </div>
                                            <div class="col-3 border-1 text-break  p-2 bg-grey-lighter border-l-0 border-t-0">
                                                Quantity
                                            </div>
                                            <div class="col-3 border-1 text-break  border-l-0 p-2 border-l-0 bg-grey-lighter border-t-0">
                                                Item total
                                            </div>
                                        </div>
                                        <div class="row m-0 p-0 text-sm" v-for="(line, lineIndex) in qbEstimate.Estimate.Line" v-if="lineIndex < qbEstimate.Estimate.Line.length-1">
                                            <div class="col-3 border-1 text-break  p-2 border-t-0">
                                                {{ line.SalesItemLineDetail.ItemRef.name }}
                                            </div>
                                            <div class="col-3 border-1 text-break  border-l-0 p-2 border-t-0">
                                                ${{  line.SalesItemLineDetail.UnitPrice }}
                                            </div>
                                            <div class="col-3 border-1 text-break  border-l-0 p-2 border-t-0">
                                                {{  line.SalesItemLineDetail.Qty }}
                                            </div>
                                            <div class="col-3 border-1 text-break  border-l-0 p-2 border-t-0">
                                                ${{  line.Amount }}
                                            </div>
                                        </div>
                                        <div class="row m-0 p-0 text-sm" v-if="qbEstimate.Estimate.Line.length > 0">
                                            <div class="col-9 border-1 text-break  p-2 bg-grey-lighter border-t-0">
                                                Total
                                            </div>
                                            <div class="col-3 border-1 text-break  border-l-0 p-2 border-l-0 border-t-0">
                                                ${{ qbEstimate.Estimate.Line[qbEstimate.Estimate.Line.length-1].Amount }}
                                            </div>
                                        </div>
                                        <br>
                                        <div class="text-right w-full">
                                            <button type="button" class="btn btn-primary text-sm" @click="editEstimate(qbEstimate)">Edit this estimate</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!--   List QB all projects    -->
        <div class="modal fade" id="listQBAllProjects" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLongTitle"><img class="qb-small-logo-estimate" src="https://prod-followupcrm.s3.us-east-2.amazonaws.com/qb-logo-small.png">All QuickBooks Projects</h5>
                        <button type="button" class="close" aria-label="Close" @click="closeListQBAllProjectsModal">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body bg-white">
                        <div class="loadingOverlayListProjects">
                            <div class="cv-spinner">
                                <span class="spinner"></span>
                                <span class="text-white ml-4 text-xl ">Fetching QuickBooks Projects</span>
                            </div>
                        </div>
                        <div class="loadingOverlayFetchInvoices">
                            <div class="cv-spinner">
                                <span class="spinner"></span>
                                <span class="text-white ml-4 text-xl ">Fetching Project Invoices</span>
                            </div>
                        </div>
                        <div class="mt-2">
                            <div class="row">
                                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 form-group" v-if="qbAllProjects.length > 0">
                                    <label for="user">QuickBooks Projects</label>
                                    <multiselect
                                        class="cursor-pointer w-full"
                                        :options="qbAllProjects"
                                        v-model="selectedQBProject"
                                        label="DisplayName"
                                        placeholder="Search and Select..."
                                        :multiple="false"
                                        track-by="id"
                                        :show-labels="false"
                                        :taggable="false"
                                        :close-on-select="true"
                                    >
                                    </multiselect>
                                </div>
                                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 form-group text-center" v-else>
                                    No projects found
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer bg-white">
                        <button type="button" class="btn btn-secondary" @click="closeListQBAllProjectsModal">Close</button>
                        <button type="button" class="btn btn-primary" @click="selectQBProject()" :disabled="selectProjectButton">Select Project</button>
                    </div>
                </div>
            </div>
        </div>

        <!--   Select or create QB customer    -->
        <div class="modal fade" id="selectOrCreateQBCustomer" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLongTitle"><img class="qb-small-logo-estimate" src="https://prod-followupcrm.s3.us-east-2.amazonaws.com/qb-logo-small.png">Select/Create QuickBooks Customer</h5>
                        <button type="button" class="close" aria-label="Close" @click="closeSelectOrCreateQBCustomer()">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body bg-white">
                        <div class="loadingOverlayFetchingCustomer">
                            <div class="cv-spinner">
                                <span class="spinner"></span>
                                <span class="text-white ml-4 text-xl ">Fetching QuickBooks Customers</span>
                            </div>
                        </div>
                        <div class="row d-flex align-items-baseline px-4 mb-2">
                            <div class="col-md-2 p-0 m-0">
                                <label class="text-black text-sm p-0 m-0 pr-1">Customer Name</label>
                            </div>
                            <div class="col-md-7">
                                <multiselect
                                    class="cursor-pointer w-full"
                                    :options="qbCustomers"
                                    v-model="selectedQBCustomer"
                                    label="DisplayName"
                                    placeholder="Search and Select..."
                                    :multiple="false"
                                    track-by="Id"
                                    :show-labels="true"
                                    :taggable="false"
                                    :close-on-select="true"
                                    :disabled="(selectedEstimateForEdit || project.quick_book_customer_id)? true:false"
                                >
                                </multiselect>
                            </div>
                            <div class="col-md-3">
                                <button type="button" class="btn btn-primary w-full" @click="createQBCustomerModal()" v-if="(selectedEstimateForEdit || project.quick_book_customer_id)? false:true">Create customer</button>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer bg-white">
                        <div class="customerInformationTooltip cursor-pointer" title="Customer selected here cannot be changed for further estimates"><i class="fa fa-info-circle" aria-hidden="true"></i></div>
                        <button type="button" class="btn btn-primary" @click="selectCustomerFirstTime()">Select Customer</button>
                    </div>
                </div>
            </div>
        </div>








        <div class="modal fade" id="qbNewFlowModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
            <div class="modal-dialog  modal-lg modal-dialog-centered">
                <div class="modal-content custom-rounded-qb border-0 bg-white">
                    <!-- Modal body with circles -->
                    <div class="modal-body py-5">
                        <!-- Step circles and progress line moved here -->
                        <div class="text-center">
                            <span class="step-circle cursor-pointer" @click="stepSelect(1)" :class="{ 'filled-circle': step === 1 }"></span>
                            <span class="step-line"></span>
                            <span class="step-circle cursor-pointer" @click="stepSelect(2)" :class="{ 'filled-circle': step === 2 }"></span>
                            <span class="step-line"></span>
                            <span class="step-circle cursor-pointer" @click="stepSelect(3)" :class="{ 'filled-circle': step === 3 }"></span>
                        </div>

                        <!-- Step 1 Content -->
                        <div id="step1" class="step mt-5" v-show="step === 1">
                            <p class="text-2xl text-grey-darkest text-center w-50 m-auto">
                                Select Existing Customer or Create a New Customer In Quickbooks
                            </p>
                            <div class="row w-75 m-auto pt-5">
                                <div class="col-md-6 text-center">
                                    <button class="btn btn-primary rounded-pill w-full text-xl py-3" @click="userSelection('select')">Select Customer</button>
                                </div>
                                <div class="col-md-6 text-center">
                                    <button class="btn btn-primary rounded-pill w-full text-xl py-3" @click="userSelection('create')">Create Customer</button>
                                </div>
                            </div>
                        </div>

                        <!-- Step 2 Content -->
                        <div id="step2" class="step" v-show="step === 2">
                            <div class="loadingOverlayFetchingCustomer" v-if="userStepSelection == 'select'" style="border-radius: 50px;">
                                <div class="cv-spinner">
                                    <span class="spinner"></span>
                                    <span class="text-white ml-4 text-xl ">Fetching QuickBooks Customers</span>
                                </div>
                            </div>
                            <div class="loadingoverlayCustomer" v-if="userStepSelection == 'create'" style="border-radius: 50px;">
                                <div class="cv-spinner">
                                    <span class="spinner"></span>
                                    <span class="text-white ml-4 text-xl ">Creating/Linking QuickBooks Customer</span>
                                </div>
                            </div>
                            <p class="text-xl text-grey-darkest text-center w-50 m-auto pt-5 " v-if="userStepSelection == 'select'">
                                Select an Existing Customer In Quickbooks
                            </p>
                            <div class="row w-75 m-auto pt-5" v-if="userStepSelection == 'select'">
                                <div class="col-md-3 p-0 m-0 text-right d-flex align-items-center flex-row-reverse">
                                    <label class="text-black p-0 m-0 pr-1">Customer Name</label>
                                </div>
                                <div class="col-md-9">
                                    <multiselect
                                        class="cursor-pointer w-full"
                                        :options="qbCustomers"
                                        v-model="selectedQBCustomer"
                                        label="DisplayName"
                                        placeholder="Search and Select..."
                                        :multiple="false"
                                        track-by="Id"
                                        :show-labels="true"
                                        :taggable="false"
                                        :close-on-select="true"
                                        :disabled="(selectedEstimateForEdit || project.quick_book_customer_id)? true:false"
                                    >
                                    </multiselect>
                                </div>
                            </div>
                            <p class="text-xl text-grey-darkest text-center w-50 m-auto pt-5" v-if="userStepSelection == 'create'">
                                Create New Customer In Quickbooks
                            </p>
                            <div class="row w-75 m-auto pt-5" v-if="userStepSelection == 'create'">
                                <div class="col-md-3 p-0 m-0">
                                    <label class="text-black p-0 m-0 pr-1 text-right d-flex align-items-center flex-row-reverse">Select Contact</label>
                                </div>
                                <div class="col-md-9">
                                    <multiselect
                                        id="selectProjectOrCompanyContactForQB"
                                        v-model="selectedContactForQB"
                                        :options="optionsForQBArray"
                                        :multiple="false"
                                        :close-on-select="true"
                                        :clear-on-select="false"
                                        :preserve-search="false"
                                        :taggable="false"
                                        open-direction="below"
                                        placeholder="Pick a Contact"
                                        :showLabels="false"
                                        label="displayName"
                                        track-by="id"
                                        :preselect-first="false"
                                        group-values="contact_options"
                                        group-label="contact_type"
                                        :group-select="false">
                                    </multiselect>
                                </div>
                            </div>
                            <div class="row w-75 m-auto pt-5" v-if="selectedContactForQB && userStepSelection == 'create'">
                                <h5 class="font-weight-light text-white bg-primary mx-3 p-2 w-full">Contact Information</h5>
                                <div class="row mx-3 text-sm w-full">
                                    <div class="col-3 border-1 text-break  p-2 bg-grey-lighter">
                                        Name
                                    </div>
                                    <div class="col-3 border-1 text-break  border-l-0 p-2 text-sm">
                                        {{ selectedContactForQB.name }}
                                    </div>
                                    <div class="col-3 border-1 text-break  p-2 bg-grey-lighter border-l-0">
                                        Email
                                    </div>
                                    <div class="col-3 border-1 text-break  border-l-0 p-2 border-l-0">
                                        {{  selectedContactForQB.email }}
                                    </div>
                                </div>
                                <div class="row mx-3 text-sm w-full">
                                    <div class="col-3 border-1 text-break  p-2 bg-grey-lighter border-t-0">
                                        Type
                                    </div>
                                    <div class="col-3 border-1 text-break  border-l-0 p-2 border-t-0">
                                        {{  (selectedContactForQB.type == 'project_contact')? 'Project Contact':'Company Contact' }}
                                    </div>
                                    <div class="col-3 border-1 text-break  p-2 bg-grey-lighter border-t-0 border-l-0">
                                        Cell
                                    </div>
                                    <div class="col-3 border-1 text-break  border-l-0 p-2 border-t-0 border-l-0">
                                        {{  selectedContactForQB.cell }}
                                    </div>
                                </div>
                                <div class="row mx-3 text-sm w-full" v-if="projectContactCompany && selectedContactForQB.type == 'project_contact'">
                                    <div class="col-3 border-1 text-break  p-2 bg-grey-lighter border-t-0">
                                        Company name
                                    </div>
                                    <div class="col-3 border-1 text-break  border-l-0 p-2 border-t-0">
                                        {{  projectContactCompany.name }}
                                    </div>
                                    <div class="col-3 border-1 text-break  p-2 bg-grey-lighter border-t-0 border-l-0">
                                        Company Address
                                    </div>
                                    <div class="col-3 border-1 text-break  border-l-0 p-2 border-t-0 border-l-0">
                                        {{  projectContactCompany.address }}
                                    </div>
                                </div>
                                <div class="row mx-3 text-sm w-full" v-if="selectedContactForQB.company && selectedContactForQB.type == 'company_contact'">
                                    <div class="col-3 border-1 text-break  p-2 bg-grey-lighter border-t-0">
                                        Company name
                                    </div>
                                    <div class="col-3 border-1 text-break  border-l-0 p-2 border-t-0">
                                        {{  selectedContactForQB.company.name }}
                                    </div>
                                    <div class="col-3 border-1 text-break  p-2 bg-grey-lighter border-t-0 border-l-0">
                                        Company Address
                                    </div>
                                    <div class="col-3 border-1 text-break  border-l-0 p-2 border-t-0 border-l-0">
                                        {{  selectedContactForQB.company.address }}
                                    </div>
                                </div>
                            </div>

                            <div class="row m-auto pt-5">
                                <div class="col-md-4">
                                    <button class="btn btn-secondary rounded-pill w-full py-3" @click="stepSelect(1)">Back</button>
                                </div>
                                <div class="col-md-4">
                                </div>
                                <div class="col-md-4">
                                    <button v-if="userStepSelection == 'select'" class="btn btn-primary rounded-pill w-full py-3" @click="selectCustomerFirstTime()">Select Customer</button>
                                    <button v-if="userStepSelection == 'create'" class="btn btn-primary rounded-pill w-full py-3" @click="createQBCustomer()" >Create Customer</button>
                                </div>
                            </div>
                        </div>

                        <!-- Step 3 Content -->
                        <div id="step3" class="step" v-show="step === 3">
                            <div class="loadingOverlayListProjects" style="border-radius: 50px;">
                                <div class="cv-spinner">
                                    <span class="spinner"></span>
                                    <span class="text-white ml-4 text-xl ">Fetching QuickBooks Projects</span>
                                </div>
                            </div>
                            <div class="loadingOverlayFetchInvoices" style="border-radius: 50px;">
                                <div class="cv-spinner">
                                    <span class="spinner"></span>
                                    <span class="text-white ml-4 text-xl ">Syncing Project Data</span>
                                </div>
                            </div>
                            <p class="text-xl text-grey-darkest text-center w-50 m-auto pt-5" v-if="qbAllProjects.length > 0">
                                Select a Project Associated to {{(selectedQBCustomer)? selectedQBCustomer.DisplayName:''}}
                            </p>
                            <div class="row w-75 m-auto pt-5" v-if="qbAllProjects.length > 0">
                                <div class="col-md-4 p-0 m-0">
                                    <label class="text-black p-0 m-0 pr-1 text-right d-flex align-items-center flex-row-reverse">QuickBooks Projects</label>
                                </div>
                                <div class="col-md-8">
                                    <multiselect
                                        class="cursor-pointer w-full"
                                        :options="qbAllProjects"
                                        v-model="selectedQBProject"
                                        label="DisplayName"
                                        placeholder="Search and Select..."
                                        :multiple="false"
                                        track-by="Id"
                                        :show-labels="false"
                                        :taggable="false"
                                        :close-on-select="true"
                                    >
                                    </multiselect>
                                </div>
                            </div >
                            <div class="row w-75 m-auto pt-5" v-else>
                                <div class="col-md-12 p-0 m-0 text-center">
                                    <label class="text-xl text-grey-darkest text-center m-auto">There are no projects associated to {{(selectedQBCustomer)? selectedQBCustomer.DisplayName:''}} within Quickbooks.</label>
                                    <label class="text-xl text-grey-darkest text-center m-auto ">Once a project has been created within Quickbooks, it will automatically appear here.</label>
                                </div>
                            </div>
                            <div class="row m-auto pt-5">
                                <div class="col-md-4">
                                    <button v-if="!this.selectedQBCustomer" class="btn btn-secondary rounded-pill w-full py-3" @click="stepSelect(2)">Back</button>
                                </div>
                                <div class="col-md-4">
                                </div>
                                <div class="col-md-4">
                                    <button v-if="qbAllProjects.length > 0" class="btn btn-primary rounded-pill w-full py-3" @click="selectQBProject()">Link and Sync Project Data</button>
                                    <button v-else class="btn btn-success rounded-pill w-full py-3" @click="gotoQuickBook()">Create Project in Quickbooks</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>










    </div>
</template>
<script>
import axios from "axios";
import Multiselect from "vue-multiselect";

export default {
    name: 'quick-book-estimate',
    props: ['project', 'selects', 'quickBookEstimates', 'team', 'companyContacts'],
    components: {Multiselect},
    data() {
        return {
            estimateId: this.project.id,
            qbCustomers: [],
            selectedQBCustomer: null,
            projectContact: this.project.contact,
            projectContactCompany: null,
            buttonDisabled: false,
            productAndServices: [],
            changeOrders: this.project.change_orders,
            addLineItems: false,
            quickBookContractItems: [
                {
                    item: null,
                    value: 0,
                    quantity: 0,
                    subTotal: 0,
                    editable: true
                }
            ],
            quickBookChangeOrders:[],
            qbEstimates:[],
            selectedEstimateForEdit: null,
            selectedEstimateForEditId: null,
            qbAllProjects: [],
            selectedQBProject: null,
            creatingOrSelectingCustomerFirstTime: false,
            projectData: this.project,
            selectProjectButton: false,
            step: 1,
            userStepSelection: null,
            selectedContactForQB: null,
            optionsForQBArray: []
        }
    },
    mounted() {
        this.fetchingData();
        this.optionsForQB();
    },
    created() {

    },
    watch: {
        // companyContacts(val) {
        //     this.optionsForQB();
        // },
    },
    methods: {
        fetchingData(){
            if(this.team.is_quick_book_connected && this.team.has_quick_book_access){
                this.decodeEstimates();
                this.getContactInformation();
                this.fetchAllQBProductAndSerivices();
                this.fetchAllQBCustomers();
                this.fetchQBProjects();
            }
        },
        openQuickBookCreateModal(){
            this.fetchAllQBCustomers();
            $('#createEstimateQuickBook').modal('show');
            $('.customerInformationTooltip').tooltip();
        },
        closeQuickBookCreateModal(){
            $('#createEstimateQuickBook').modal('hide');
            this.selectedEstimateForEdit = null;
            this.addLineItems = false;
            this.quickBookContractItems = [{
                item: null,
                value: 0,
                quantity: 0,
                subTotal: 0,
                editable: true
            }];
        },
        fetchAllQBCustomers(qbCustomer = null){
            this.buttonDisabled = true;
            this.showLoader();
            $('.loadingOverlayFetchingCustomer').fadeIn();
            let contactEmail = {email: (this.project.contact)? this.project.contact.email:null, projectId: this.project.id, createdLinkedCustomer: qbCustomer};
            axios.post(route('quick-book.fetch-all-quick-book-customer'), contactEmail).then((response) => {
                    this.qbCustomers = response.data.qbCustomers;
                    this.selectedQBCustomer = response.data.qbCustomer;
                    this.buttonDisabled = false;
                    this.hideLoader();
                $('.loadingOverlayFetchingCustomer').fadeOut();
            });
        },
        createQBCustomerModal(){
            if((this.project.contact.email == '' || this.project.contact.email == null || this.project.contact.name == '' || this.project.contact.name == null) && this.companyContacts.length == 0){
                this.getToast().fire({
                    type: 'error',
                    title: 'Please select company contact or add name and email in project contact'
                });
                return false;
            }
            this.selectedContactForQB = null;
            $('#selectOrCreateQBCustomer').modal('hide');
            $('#createEstimateQuickBook').modal('hide');
            $('#createQBCustomerModal').modal('show');
        },
        createQBCustomerModalClose(){
            $('#createQBCustomerModal').modal('hide');
            $('#createEstimateQuickBook').modal('show');
        },
        getContactInformation(){
            if(this.project.contact){
                axios.post(route('quick-book.get-project-contact-information'), {id: this.project.contact.id}).then((response) => {
                    this.projectContact = response.data.projectContact;
                    this.projectContactCompany = response.data.company;
                });
            }
        },
        showLoader(){
            $("#loadingoverlay").fadeIn();
        },
        hideLoader(){
            $("#loadingoverlay").fadeOut();
        },
        showLoaderCustomer(){
            $(".loadingoverlayCustomer").fadeIn();
        },
        hideLoaderCustomer(){
            $(".loadingoverlayCustomer").fadeOut();
        },
        createQBCustomer(forEstimate = null){
            if(this.selectedContactForQB !== null && this.selectedContactForQB !== undefined){
                if(this.selectedContactForQB.name == '' || this.selectedContactForQB.email == '' || this.selectedContactForQB.email == null || this.selectedContactForQB.name == null){
                    this.getToast(3500).fire({
                        type: 'error',
                        title: 'Please select contact with valid email and name'
                    });
                    return false;
                }
                this.buttonDisabled = true;
                this.showLoaderCustomer();
                axios.post(route('quick-book.create-customer-from-project-contact'), {contact: this.selectedContactForQB, projectId: this.project.id}).then((response) => {
                    this.buttonDisabled = false;
                    if(response.data.status == 'success'){
                        this.getToast().fire({
                            type: 'success',
                            title: response.data.message
                        });
                        this.$parent.projectDataFroQB = response.data.project;
                        // if(!this.creatingOrSelectingCustomerFirstTime){
                        //     this.createQBCustomerModalClose();
                            // this.fetchAllQBCustomers(response.data.customer.Customer);
                        if(forEstimate){
                            this.hideLoaderCustomer();
                            this.createQBCustomerModalClose();
                            this.fetchAllQBCustomers();
                        }else{
                            this.hideLoaderCustomer();
                            this.step = 3;
                            this.fetchingData();
                            this.selectedQBCustomer = response.data.qbCustomer;
                        }


                        // }else{
                        //     // this.fetchAllQBCustomers(response.data.customer.Customer);
                        //     $('#createQBCustomerModal').modal('hide');
                        //     // this.openListQBAllProjectsModal();
                        //     this.hideLoaderCustomer();
                        // }
                    }else{
                        this.getToast(3500).fire({
                            type: 'error',
                            title: response.data.message
                        });
                        this.hideLoaderCustomer();
                        return false;
                    }
                });
            }else{
                this.getToast().fire({
                    type: 'error',
                    title: 'Please select a contact from dropdown'
                });
                return false;
            }
        },
        fetchAllQBProductAndSerivices(){
            axios.post(route('quick-book.fetch-all-quick-book-product-and-services')).then((response) => {
                this.productAndServices = response.data.productAndServices;
            });
        },
        addLineItemsMethod(){
            this.addLineItems = true;
        },
        addItemToQuickBookContractItems(){
            let item = {
                item: null,
                value: 0,
                quantity: 0,
                subTotal: 0,
                editable: true
            };
            this.quickBookContractItems.push(item);
        },
        removeItemFromQuickBookContractItems(index){
            this.quickBookContractItems.splice(index, 1);
            if(this.quickBookContractItems.length == 0){
                this.addItemToQuickBookContractItems();
            }
        },
        calculateItemSubTotal(index){
            this.$nextTick(() => {
                if(this.quickBookContractItems[index].item){
                    this.quickBookContractItems[index].value = this.quickBookContractItems[index].item.UnitPrice;
                    this.quickBookContractItems[index].subTotal = this.quickBookContractItems[index].item.UnitPrice * this.quickBookContractItems[index].quantity;
                }
            });
        },
        createEstimate(){
            if(!this.selectedQBCustomer){
                this.getToast().fire({
                    type: 'error',
                    title: 'Please select a customer from dropdown'
                });
                return false;
            }

            if(!this.addLineItems){
                this.getToast().fire({
                    type: 'error',
                    title: 'Please add line items'
                });
                return false;
            }

            let errorArray = [];
            this.quickBookContractItems.forEach(item => {
               if(!item.item || item.quantity == '' || item.quantity == null || item.quantity == 0){
                   errorArray.push('true');
               }
            });

            if(errorArray.includes('true')){
                this.getToast().fire({
                    type: 'error',
                    title: 'Please fill in all fields of line items'
                });
                return false;
            }

            this.buttonDisabled = true;
            this.openCreateloadingoverlay();
            axios.post(route('quick-book.create-quick-book-estimate'), { projectId: this.project.id, qbCustomer: this.selectedQBCustomer, lineItems: this.quickBookContractItems }).then((response) => {
                this.buttonDisabled = false;
                this.closeCreateloadingoverlay();
                this.getToast().fire({
                    type: 'success',
                    title: response.data.message
                });
                this.closeQuickBookCreateModal();
                this.selectedQBCustomer = null;
                this.quickBookContractItems = [{
                    item: null,
                    value: 0,
                    quantity: 0,
                    subTotal: 0,
                    editable: true
                }];
                this.addLineItems = false;
                this.selectedEstimateForEdit = null;
                window.location.reload();
            });
        },
        openCreateloadingoverlay(){
            $("#createloadingoverlay").fadeIn();
        },
        closeCreateloadingoverlay(){
            $("#createloadingoverlay").fadeOut();
        },
        openQuickBookEstimateListModal(){
            $('#listQBEstimatesModal').modal('show');
        },
        closeQuickBookEstimateListModal(){
            $('#listQBEstimatesModal').modal('hide');
        },
        decodeEstimates(){
            if(this.quickBookEstimates.length > 0){
                this.quickBookEstimates.forEach(item => {
                    if(item.estimate){
                        let estimateOBJ = JSON.parse(item.estimate);
                        estimateOBJ['estimateDBId'] = item.id;
                        this.qbEstimates.push(estimateOBJ)
                    }
                });
            }
        },
        formatEstimateDate(date){
            return moment(date).format("MM-DD-yyyy h:mm a");
        },
        editEstimate(qbEstimateData){
            let qbEstimate = qbEstimateData;
            this.selectedEstimateForEdit = qbEstimate;
            this.selectedQBCustomer = this.qbCustomers.find(customer => customer.Id == qbEstimate.Estimate.CustomerRef.value);
            let lineItems = [];
            let lineArray = qbEstimate.Estimate.Line;
            for(let i = 0; i < lineArray.length-1; i++){
                let item = lineArray[i];
                lineItems.push({
                    item: this.productAndServices.find(itemDetail => itemDetail.Id == item.SalesItemLineDetail.ItemRef.value),
                    quantity:  item.SalesItemLineDetail.Qty,
                    subTotal: item.Amount,
                    value: item.SalesItemLineDetail.UnitPrice,
                    editable: false
                });
            }

            this.quickBookContractItems = lineItems;
            this.addLineItems = true;
            this.closeQuickBookEstimateListModal();
            this.openQuickBookCreateModal();
        },
        updateEstimate(){
            let errorArray = [];
            this.quickBookContractItems.forEach(item => {
                if(!item.item || item.quantity == '' || item.quantity == null || item.quantity == 0){
                    errorArray.push('true');
                }
            });

            if(errorArray.includes('true')){
                this.getToast().fire({
                    type: 'error',
                    title: 'Please fill in all fields of line items'
                });
                return false;
            }
            this.buttonDisabled = true;
            this.openCreateloadingoverlay();
            axios.post(route('quick-book.update-quick-book-estimate'), { projectId: this.project.id, qbCustomer: this.selectedQBCustomer, lineItems: this.quickBookContractItems, selectedEstimate: this.selectedEstimateForEdit }).then((response) => {
                if(response.data.status == 'error'){
                    this.getToast().fire({
                        type: 'error',
                        title: response.data.message
                    });
                    return false;
                }
                this.buttonDisabled = false;
                this.closeCreateloadingoverlay();
                this.getToast().fire({
                    type: 'success',
                    title: response.data.message
                });
                this.closeQuickBookCreateModal();
                this.selectedQBCustomer = null;
                this.quickBookContractItems = [{
                    item: null,
                    value: 0,
                    quantity: 0,
                    subTotal: 0,
                    editable: true
                }];
                this.addLineItems = false;
                this.selectedEstimateForEdit = null;
                setTimeout(() => {
                    window.location.reload();
                }, 1000);
            });
        },
        fetchQBProjects(){
            // if(this.project.quick_book_customer_id){
                $('.loadingOverlayListProjects').fadeIn();
                this.selectProjectButton = true;
                axios.post(route('quick-book.get-quick-book-projects'), {projectId: this.project.id}).then((response) => {
                    this.qbAllProjects = response.data.qbProjects;
                    if(this.project.quick_book_project_id){
                        this.selectedQBProject = this.qbAllProjects.find(x => x.Id == this.project.quick_book_project_id);
                    }
                    $('.loadingOverlayListProjects').fadeOut();
                    this.selectProjectButton = false;
                });
            // }
        },
        openListQBAllProjectsModal(){
            if(this.project.quick_book_customer_id){
                this.fetchQBProjects();
                this.step = 3;
                $('#qbNewFlowModal').modal('show');
                // $('#listQBAllProjects').modal('show');
            }else{
                this.creatingOrSelectingCustomerFirstTime = true;
                this.step = 1;
                $('#qbNewFlowModal').modal('show');
                // $('#selectOrCreateQBCustomer').modal('show');
                // $('.customerInformationTooltip').tooltip();
            }
        },
        closeListQBAllProjectsModal(){
            $('#listQBAllProjects').modal('hide');
        },
        selectCustomerFirstTime(){
            if(this.selectedQBCustomer){
                axios.post(route('quick-book.select-quick-book-customer-first-time'), {projectId: this.project.id, customerId: this.selectedQBCustomer.Id}).then((response) => {
                    this.$parent.projectDataFroQB = response.data.project;
                    this.creatingOrSelectingCustomerFirstTime = false;
                    this.getToast().fire({
                        type: 'success',
                        title: 'Customer selected successfully'
                    });
                    this.$nextTick(() => {
                        $('#selectOrCreateQBCustomer').modal('hide');
                        $('#createQBCustomerModal').modal('hide');
                        // this.openListQBAllProjectsModal();
                        this.step = 3;
                        this.fetchingData();
                    })
                });
            }else{
                this.getToast().fire({
                    type: 'error',
                    title: 'Please select a customer'
                });
                return false;
            }
        },
        closeSelectOrCreateQBCustomer(){
            $('#selectOrCreateQBCustomer').modal('hide');
            this.creatingOrSelectingCustomerFirstTime = false;
        },
        selectQBProject(){
            if(this.selectedQBProject == '' || this.selectedQBProject == null){
                this.getToast().fire({
                    type: 'error',
                    title: 'Please select a project'
                });
                return false;
            }else{
                this.getToast().fire({
                    type: 'success',
                    title: 'Project selected, fetching invoices'
                });
                $('.loadingOverlayFetchInvoices').fadeIn();
                this.selectProjectButton = true;
                axios.post(route('quick-book.select-quick-book-project'), {projectId: this.project.id, selectedQBProject: this.selectedQBProject.Id}).then((response) => {
                    // let data = {};
                    // if(response.data.invoiceData.invoiceData){
                    //     data = {
                    //         invoiceData: Object.entries(response.data.invoiceData.invoiceData),
                    //         invoiceTotal: response.data.invoiceData.invoiceTotal
                    //     };
                    // }else{
                    //     data = {
                    //         invoiceData: null,
                    //         invoiceTotal: response.data.invoiceData.invoiceTotal
                    //     }
                    // }
                    // this.$parent.quickBookInvoiceData = data;
                    this.selectProjectButton = false;
                    $('.loadingOverlayFetchInvoices').fadeOut();
                    $('#listQBAllProjects').modal('hide');
                    window.location.reload();
                    this.closeModal();
                    this.$parent.syncQBProjectInvoice();
                });
            }
        },

        openNewQBFlowModal() {
            this.step = 1;
            console.log('in');
            $('#qbNewFlowModal').modal('show');
        },
        closeModal() {
            $('#qbNewFlowModal').modal('hide');
        },
        nextStep() {
            if (this.step < 3) {
                this.step++;
            }
        },
        prevStep() {
            if (this.step > 1) {
                this.step--;
            }
        },
        stepSelect(stepNumber){
            if(this.selectedQBCustomer && stepNumber == 3){
                this.step = stepNumber;
            }else if(this.userStepSelection && stepNumber == 2){
                this.step = stepNumber;
            }else if(this.userStepSelection && stepNumber == 1){
                this.step = stepNumber;
            }
        },
        userSelection(selection){
            this.userStepSelection = selection;
            this.$nextTick(() => {
                this.step = 2;
            });
        },
        gotoQuickBook(){
            let QBurl = process.env.MIX_QUICK_BOOK_ACCOUNT_BASE_URL;
            window.open(QBurl+"app/projects", "_blank");
        },
        optionsForQB() {
            let contactArray = [];
            if(this.project.contact){
                if(this.project.contact.email !== '' && this.project.contact.email !== null && this.project.contact.name !== '' && this.project.contact.name !== null){
                    let projectContact  = {
                        contact_type: 'Project Contact',
                        contact_options: [
                            {...this.project.contact, type: 'project_contact', displayName: this.project.contact.name},
                        ]
                    };
                    contactArray.push(projectContact);
                }
            }

            if(this.companyContacts.length > 0){
                let companyContactOptions = [];
                this.companyContacts.forEach(item => {
                    companyContactOptions.push({...item, type: 'company_contact', displayName: item.name+' ('+item.company.name+')'});
                });
                let companyContact  = {
                    contact_type: 'Company Contact',
                    contact_options: companyContactOptions
                };
                contactArray.push(companyContact);
            }
            this.optionsForQBArray = contactArray;
        },
    }
}
</script>
<style scoped>
    img.qb-small-logo-estimate {
        width: 24px;
        height: auto;
        margin-right: 8px;
        padding-bottom: 3px;
    }
    #loadingoverlay,
    .loadingoverlayCustomer,
    #createloadingoverlay,
    .loadingOverlayListProjects,
    .loadingOverlayFetchingCustomer,
    .loadingOverlayFetchInvoices{
        position: absolute;
        top: 0;
        left: 0;
        z-index: 100;
        width: 100%;
        height: 100%;
        display: none;
        background: rgb(0 0 0 / 57%);
    }

    .cv-spinner {
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .spinner {
        width: 40px;
        height: 40px;
        border: 4px #ddd solid;
        border-top: 4px #2e93e6 solid;
        border-radius: 50%;
        animation: sp-anime 0.8s infinite linear;
    }

    @keyframes sp-anime {
        0% {
            transform: rotate(0deg);
        }

        100% {
            transform: rotate(359deg);
        }
    }

    .customerInformationTooltip{
        margin-right: auto;
        order: 0;
        font-size: 20px;
    }








    .step-circle {
        width: 30px;
        height: 30px;
        background-color: #7A797A;
        border-radius: 50%;
        display: inline-flex;
        justify-content: center;
        align-items: center;
        font-weight: bold;
    }

    .step-line {
        width: 109px;
        height: 2px;
        background-color: #BDC0C4;
        display: inline-block;
        margin: 0 -4px;
        top: -13px;
        position: relative;
    }

    .filled-circle {
        background-color: #01b1af !important;
        color: #fff !important;
    }

    .custom-rounded-qb {
        border-radius: 50px;
    }
</style>
